<style>
#addVarianceModal .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 400px !important;
}
#addVarianceModal .modal__content {
  overflow-y: auto !important;
}
#addVarianceModal .v-text-field__slot input,
#addVarianceModal div.v-select__slot > label,
#addVarianceModal .v-text-field__slot label,
#addVarianceModal .v-select__selection.v-select__selection--comma {
  font-size: 12px !important;
}
#addVarianceModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
</style>

<template>
  <Modal
    modalName="addVarianceModal"
    title="DODAJ ROZBIEŻNOŚĆ"
    :buttons="['save']"
    @opened="getVariances(), getVariancesStatus(), getVariancesType()"
    @saved="addVariance"
    @closed="close"
    :isNewObject="isNewVariance"
    :hideButtons__right="!isNewVariance"
  >
    <div>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-subheader>PODSTAWOWE INFORMACJE O ROZBIEŻNOŚCI</v-subheader>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="font--primary"
      >
        <v-flex xs12>
          <v-text-field
            label="Nazwa"
            height="16"
            v-model="name"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-select
            :items="variancesType.values"
            v-model="type"
            label="Typ"
            height="16"
          ></v-select>
        </v-flex>
        <v-spacer />
        <v-flex
          xs5
          class="second"
        >
          <v-select
            :items="variancesStatus.values"
            v-model="status"
            label="Status"
            height="16"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-textarea
            label="Opis"
            v-model="description"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="geometry-panel"
      >
        <v-flex
          xs4
          v-if="!currentVarianceArea"
          style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
        >
          <v-icon
            class="table__btn--green geometry-panel__add-btn"
            @click="addGeometry"
          >add_circle</v-icon>
          <p
            @click="addGeometry"
            class="hover__pointer"
          >Dodaj geometrię</p>
        </v-flex>
        <v-flex
          xs4
          v-else
          style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
        >
          <v-icon class="table__btn--red geometry-panel__delete-btn">delete</v-icon>
          <p
            class="hover__pointer"
            @click="removeLayer"
          >Usuń geometrię</p>
        </v-flex>
        <v-flex xs8>
          <v-layout
            justify-space-between
            id="geometry-panel"
          >
            <p
              v-if="currentVarianceArea"
              class="msg--padding"
            >Geometria dodana</p>
            <p
              v-else
              class="msg--padding"
            >Brak dodanej geometrii</p>
            <!-- <span v-if="currentVarianceArea">
              <v-icon
                title="Przybliż do geometrii"
                class="geometry-panel__zoom-btn"
                @click="zoomToInspectionGeom"
              >zoom_in</v-icon>
            </span> -->
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <span style="display: flex;">
            <v-subheader class="font--primary">Lokalizacja</v-subheader>
            <span
              style="line-height: 48px;padding-left: 5px;"
              id="addGeomBtn"
            >
              <v-icon
                small
                title="Rysuj geometrię"
                @click="addGeometry"
                v-if="!currentVarianceArea"
              >add_circle</v-icon>
              <v-icon
                small
                title="Usuń geometrię"
                @click="removeLayer"
                v-if="currentVarianceArea"
              >delete</v-icon>
            </span>
          </span>
        </v-flex>
        <div>
          <p
            v-if="!currentVarianceArea"
            class="font--primary"
          >Brak dodanej lokalizacji</p>
          <p
            v-else
            class="font--primary"
          >Lokalizacja dodana</p>
        </div>
      </v-layout> -->
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data() {
    return {
      variancesStatus: {values: []},
      variancesType: {values: []},
      varianceID: undefined,
      layer: undefined,
      name: undefined,
      status: undefined,
      description: undefined,
      type: undefined,
      created_at: null,
      created_by: undefined,
      menuReportDate: false,
      reportDateFormatted: null,
      isNewVariance: true
    };
  },
  computed: {
    currentVarianceArea() {
      return this.$store.getters.getCurrentAddingVariance;
    }
  },
  methods: {
    zoomToInspectionGeom() {
      console.log(this.currentVarianceArea)
      // this.$root.$emit('zoomToArea', [this.videoInspectionData.geometry.coordinates]);
    },
    addVariance() {
      if(!this.name) {
        this.$root.$emit("showSnackbar", "red", "Błąd, podaj nazwę");
        return;
      } else if(!this.status) {
        this.$root.$emit("showSnackbar", "red", "Błąd, podaj status");
        return;
      } else if(!this.type) {
        this.$root.$emit("showSnackbar", "red", "Błąd, podaj typ");
        return;
      } else if(!this.currentVarianceArea) {
        this.$root.$emit("showSnackbar", "red", "Błąd, podaj lokalizację");
        return;
      } else {
        this.$root.$emit("addVariance", [
          this.description,
          this.name,
          this.status,
          this.type
        ]);
        this.close();
      }
    },
    zoomToLayer() {
      this.map
        .getView()
        .fit(this.layer.getSource().getExtent(), {duration: 1000});
    },
    removeLayer() {
      this.$store.commit("setCurrentAddingVariance", undefined);
      this.$root.$emit("removeMapLayer");
    },
    addGeometry() {
      this.$root.$emit("addNewVariance");
    },
    getVariances() {
      this.$store.dispatch("getVariances").then(r => {
        if(!r) {
          return;
        } else {
          if(this.$store.getters.getVariancesData.features.length == 0) {
            this.varianceID = 1;
          } else {
            this.varianceID =
              this.$store.getters.getVariancesData.features[
                this.$store.getters.getVariancesData.features.length - 1
              ].id + 1;
          }
        }
      });
    },
    getVariancesStatus() {
      this.$store.dispatch("getDictSTC", {
        schema: "registry",
        table: "variances",
        column: "status"
      }).then(r => {
        if(!r) {
          return;
        } else {
          this.variancesStatus = r;
        }
      });
    },
    getVariancesType() {
      this.$store.dispatch("getDictSTC", {
        column: "type",
        schema: "registry",
        table: "variances"
      }).then(r => {
        if(r) {
          this.variancesType = r;
        } else {
          console.log(r)
        }
      });
    },
    close() {
      this.$modal.hide("addVarianceModal");
      this.removeLayer();
      this.layer = undefined;
      this.name = undefined;
      this.status = undefined;
      this.type = undefined;
      this.description = undefined;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/variances/AddVariance.vue